import React, { useState, useEffect } from "react";
import { DatePicker, message } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const SelectDatePicker = ({ selectedDates, setSelectedDates }) => {
  // Set default date range to "Today"
  const defaultStartDate = dayjs();
  const defaultEndDate = dayjs();

  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);

  useEffect(() => {
    setSelectedDates([defaultStartDate, defaultEndDate]);
  }, [setSelectedDates]);

  const disabledDate = (current) => {
    return current && current.isAfter(dayjs(), "day");
  };

  const calculateEndDate = (newStart, currentEnd) => {
    const proposedEnd = newStart.add(3, "month");
    if (currentEnd && currentEnd.isAfter(newStart) && currentEnd.isBefore(proposedEnd)) {
      return currentEnd;
    }
    return proposedEnd.isAfter(dayjs()) ? dayjs() : proposedEnd;
  };

  const handleDateChange = (newStart) => {
    const newEnd = calculateEndDate(newStart, endDate);
    setStartDate(newStart);
    setEndDate(newEnd);
    setSelectedDates([newStart, newEnd]);
  };

  const onRangeChange = (dates) => {
    console.log(dates,"dates");
    
    if (dates && dates.length === 2) {
      const newStart = dayjs(dates[0]);
      const newEnd = dayjs(dates[1]);

      // Check if the selected range is within 3 months
      const maxEndDate = newStart.add(3, "month");
      if (newEnd.isAfter(maxEndDate)) {
        message.error("The maximum allowed date range is 3 months.");
        return;
      }

      setStartDate(newStart);
      setEndDate(newEnd);
      setSelectedDates([newStart, newEnd]);
    } else {
      // setSelectedDates(['']);
      setStartDate(null);
      setEndDate(null);
    }
  };

  const onCalendarChange = (dates) => {
    if (dates && dates[0]) {
      const selectedStart = dayjs(dates[0]);
      handleDateChange(selectedStart);
    }
  };

  const rangePresets = [
    { label: "Today", value: [dayjs(), dayjs()] },
    { label: "Yesterday", value: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "days"), dayjs()] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "days"), dayjs()] },
    { label: "Last 90 Days", value: [dayjs().subtract(90, "days"), dayjs()] },
  ];

  return (
    <RangePicker
      presets={rangePresets}
      value={[startDate, endDate]}
      format="YYYY-MM-DD"
      onChange={onRangeChange}
      onCalendarChange={onCalendarChange}
      disabledDate={disabledDate}
      style={{ width: "100%" }}
      dropdownClassName="createDateRangePicker"
    />
  );
};

export default SelectDatePicker;
